import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { MomentDateAdapter, MatMomentDateModule } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import * as i1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i4 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

class YearDatePickerLibraryService {
    constructor() { }
}
YearDatePickerLibraryService.ɵfac = function YearDatePickerLibraryService_Factory(t) { return new (t || YearDatePickerLibraryService)(); };
YearDatePickerLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: YearDatePickerLibraryService, factory: YearDatePickerLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(YearDatePickerLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
const MY_FORMATS = {
    parse: {
        dateInput: "YYYY"
    },
    display: {
        dateInput: "YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};
class YearDatePickerLibraryComponent {
    constructor() {
        //this.yearFormControl.setValue(this.setYear);
    }
    _yearSelectedHandler(chosenDate, datepicker) {
        this.yearFormControl.setValue(chosenDate, { emitEvent: true });
        datepicker.close();
    }
}
YearDatePickerLibraryComponent.ɵfac = function YearDatePickerLibraryComponent_Factory(t) { return new (t || YearDatePickerLibraryComponent)(); };
YearDatePickerLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: YearDatePickerLibraryComponent, selectors: [["year-date-picker-library"]], inputs: { yearFormControl: "yearFormControl" }, features: [i0.ɵɵProvidersFeature([
            // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
            // application's root module. We provide it at the component level here, due to limitations of
            // our example generation script.
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE]
            },
            { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
        ])], decls: 5, vars: 3, consts: [["appearance", "outline", 1, "mt-0", "date-field", "w-100", "step-date-wrong-invalid-shown"], ["matInput", "", "maxlength", "4", "type", "number", 3, "matDatepicker", "formControl", "click"], ["matSuffix", "", 3, "for"], ["startView", "multi-year", "panelClass", "year-picker", 3, "yearSelected"], ["dp", ""]], template: function YearDatePickerLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-form-field", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("click", function YearDatePickerLibraryComponent_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(4); return _r0.open(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "mat-datepicker-toggle", 2);
        i0.ɵɵelementStart(3, "mat-datepicker", 3, 4);
        i0.ɵɵlistener("yearSelected", function YearDatePickerLibraryComponent_Template_mat_datepicker_yearSelected_3_listener($event) { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(4); return ctx._yearSelectedHandler($event, _r0); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matDatepicker", _r0)("formControl", ctx.yearFormControl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", _r0);
    } }, directives: [i1.MatFormField, i2.MatInput, i3.NumberValueAccessor, i4.MatDatepickerInput, i3.DefaultValueAccessor, i3.MaxLengthValidator, i3.NgControlStatus, i3.FormControlDirective, i4.MatDatepickerToggle, i1.MatSuffix, i4.MatDatepicker], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(YearDatePickerLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'year-date-picker-library',
                templateUrl: 'year-date-picker-library.component.html',
                styles: [],
                providers: [
                    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
                    // application's root module. We provide it at the component level here, due to limitations of
                    // our example generation script.
                    {
                        provide: DateAdapter,
                        useClass: MomentDateAdapter,
                        deps: [MAT_DATE_LOCALE]
                    },
                    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
                ]
            }]
    }], function () { return []; }, { yearFormControl: [{
            type: Input
        }] }); })();

// import { MatTooltipModule } from '@angular/material/tooltip';
// import { MatChipsModule } from '@angular/material/chips';
// import { SaveAsDraftModule } from 'save-as-draft';
// import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
// import { FileDownloadLibraryModule } from 'file-download-library';
class YearDatePickerLibraryModule {
}
YearDatePickerLibraryModule.ɵfac = function YearDatePickerLibraryModule_Factory(t) { return new (t || YearDatePickerLibraryModule)(); };
YearDatePickerLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: YearDatePickerLibraryModule });
YearDatePickerLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            // NotificationComponentLibraryModule,
            // SendBackComponentLibraryModule,
            DeleteDialogLibraryModule,
            FileUploadLibraryModule,
            // LastUpdateLibraryModule,
            // AssigningTaskLibraryModule,
            // MaximizeDialogLibraryModule,
            // CustomQuestionnaireModule,
            // MatRadioModule,
            // FileUploadDeafultLibraryModule,
            // FileDownloadLibraryModule,
            // MatSidenavModule,
            // MatListModule,
            // MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            // MatDividerModule,
            // MatCardModule,
            // MatCheckboxModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatSelectModule,
            CommonModule,
            ReactiveFormsModule,
            // MatIconModule,
            // MatTabsModule,
            MatSlideToggleModule,
            MatPaginatorModule,
            MatTableModule,
            FormsModule,
            NgbModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(YearDatePickerLibraryModule, { declarations: [YearDatePickerLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        // NotificationComponentLibraryModule,
        // SendBackComponentLibraryModule,
        DeleteDialogLibraryModule,
        FileUploadLibraryModule,
        // LastUpdateLibraryModule,
        // AssigningTaskLibraryModule,
        // MaximizeDialogLibraryModule,
        // CustomQuestionnaireModule,
        // MatRadioModule,
        // FileUploadDeafultLibraryModule,
        // FileDownloadLibraryModule,
        // MatSidenavModule,
        // MatListModule,
        // MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        // MatDividerModule,
        // MatCardModule,
        // MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatSelectModule,
        CommonModule,
        ReactiveFormsModule,
        // MatIconModule,
        // MatTabsModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatTableModule,
        FormsModule,
        NgbModule], exports: [YearDatePickerLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(YearDatePickerLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [YearDatePickerLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    // NotificationComponentLibraryModule,
                    // SendBackComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    FileUploadLibraryModule,
                    // LastUpdateLibraryModule,
                    // AssigningTaskLibraryModule,
                    // MaximizeDialogLibraryModule,
                    // CustomQuestionnaireModule,
                    // MatRadioModule,
                    // FileUploadDeafultLibraryModule,
                    // FileDownloadLibraryModule,
                    // MatSidenavModule,
                    // MatListModule,
                    // MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    // MatDividerModule,
                    // MatCardModule,
                    // MatCheckboxModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatSelectModule,
                    CommonModule,
                    ReactiveFormsModule,
                    // MatIconModule,
                    // MatTabsModule,
                    MatSlideToggleModule,
                    MatPaginatorModule,
                    MatTableModule,
                    FormsModule,
                    NgbModule,
                ],
                exports: [YearDatePickerLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of year-date-picker-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MY_FORMATS, YearDatePickerLibraryComponent, YearDatePickerLibraryModule, YearDatePickerLibraryService };
//# sourceMappingURL=year-date-picker-library.js.map
